import React from "react";
import style from "./CardCarousel.module.scss";
import { API_BASE } from "../../../../constants/config";

export const CardCarousel = ({
  card,
  backgroundWhite = null,
  alone = false,
}) => {

  if (!card) return null;

  return (
    <article
      className={`${style.card} ${backgroundWhite ? style.backgroundWhite : ""} ${alone ? style.alone : ""}`}
    >
      <div className={style.quotationMarks}>
        <svg
          width="76"
          height="60"
          viewBox="0 0 76 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.14882 45.369C0.730918 43.2795 0.521969 41.0159 0.521969 38.5781C0.521969 35.0957 0.939867 31.439 1.77566 27.6083C2.68111 23.7776 4.07411 20.121 5.95465 16.6385C7.90484 13.0863 10.3774 9.88246 13.3723 7.02682C16.3673 4.17118 20.0239 1.97721 24.3422 0.444918C24.8994 0.166319 25.5262 0.0270195 26.2227 0.0270195C26.8496 0.0270195 27.4416 0.235969 27.9988 0.653867C28.556 1.07177 28.8346 1.94239 28.8346 3.26573V9.01183C27.163 10.0566 25.5262 11.3451 23.9243 12.8774C22.392 14.4097 20.999 16.1161 19.7453 17.9967C18.5612 19.8772 17.5862 21.9319 16.82 24.1607C16.1235 26.3198 15.7753 28.5486 15.7753 30.847C15.9146 30.7077 16.0887 30.6381 16.2976 30.6381C16.5762 30.6381 16.82 30.6381 17.029 30.6381C19.2577 30.6381 21.3124 31.0211 23.193 31.7873C25.0735 32.5534 26.6754 33.5982 27.9988 34.9215C29.3221 36.1752 30.3321 37.7075 31.0286 39.5184C31.7947 41.3293 32.1778 43.2795 32.1778 45.369C32.1778 47.3888 31.7947 49.2694 31.0286 51.0106C30.3321 52.6822 29.3221 54.1797 27.9988 55.503C26.6754 56.8264 25.0735 57.8711 23.193 58.6373C21.3124 59.3338 19.2577 59.682 17.029 59.682C14.7305 59.682 12.6758 59.3338 10.865 58.6373C9.05406 57.8711 7.48694 56.8264 6.1636 55.503C4.9099 54.1797 3.86516 52.6822 3.02936 51.0106C2.19356 49.2694 1.56671 47.3888 1.14882 45.369ZM44.8192 45.369C44.4013 43.2795 44.1924 41.0159 44.1924 38.5781C44.1924 35.0957 44.6102 31.439 45.446 27.6083C46.3515 23.7776 47.7445 20.121 49.625 16.6385C51.5752 13.0863 54.0478 9.88246 57.0427 7.02682C60.0377 4.17118 63.6595 1.97721 67.9081 0.444918C68.1867 0.305618 68.4653 0.201144 68.7439 0.131494C69.0921 0.0618444 69.4752 0.0270195 69.8931 0.0270195C70.5199 0.0270195 71.0771 0.235969 71.5647 0.653867C72.1219 1.07177 72.4005 1.94239 72.4005 3.26573V9.01183C70.7289 10.0566 69.127 11.3451 67.5947 12.8774C66.0624 14.4097 64.6694 16.1161 63.4157 17.9967C62.2316 19.8772 61.2565 21.9319 60.4904 24.1607C59.7939 26.3198 59.4456 28.5486 59.4456 30.847C59.5849 30.7077 59.7591 30.6381 59.968 30.6381C60.2466 30.6381 60.4904 30.6381 60.6993 30.6381C62.9281 30.6381 64.9828 31.0211 66.8633 31.7873C68.7439 32.5534 70.3458 33.5982 71.6692 34.9215C72.9925 36.1752 74.0024 37.7075 74.6989 39.5184C75.4651 41.3293 75.8482 43.2795 75.8482 45.369C75.8482 47.3888 75.4651 49.2694 74.6989 51.0106C74.0024 52.6822 72.9925 54.1797 71.6692 55.503C70.3458 56.8264 68.7439 57.8711 66.8633 58.6373C64.9828 59.3338 62.9281 59.682 60.6993 59.682C58.4009 59.682 56.3462 59.3338 54.5353 58.6373C52.7244 57.8711 51.1573 56.8264 49.834 55.503C48.5803 54.1797 47.5355 52.6822 46.6997 51.0106C45.8639 49.2694 45.2371 47.3888 44.8192 45.369Z"
            fill="#AF2EFF"
          />
        </svg>
      </div>
      <p className={style.text}>{`“${card.comment}”`}</p>
      <div className={style.data}>
        {card?.client_avatar ? (
          <picture>
            <img src={`${API_BASE}${card.client_avatar}`} alt="avatar" />
          </picture>
        ) : null}
        <div>
          <p className={style.name}>{card.client_name}</p>
          <p className={style.role}>{card.client_role}</p>
        </div>
      </div>
    </article>
  );
};
